// @ts-nocheck
document.addEventListener("DOMContentLoaded", () => {
  initButtonBar();
});

function initButtonBar() {
  const bar = document.querySelector('[data-button-bar]') || document.getElementById('button-bar');
  if (!bar) return;

  const defaultHideSelectors = [
  ];

  const dataHideSelectors = (bar.getAttribute('data-hide-selectors') || '')
    .split(',')
    .map(sel => sel.trim())
    .filter(Boolean);
  const shouldHideOnOutsideClick = (bar.getAttribute('data-hide-on-click') || '').toLowerCase() === 'true';
  const hideOnScrollUp = (bar.getAttribute('data-hide-on-scroll-up') || '').toLowerCase() === 'true';
  const hideNearTop = (bar.getAttribute('data-hide-near-top') || '').toLowerCase() === 'true';

  const hideSelectors = dataHideSelectors.length ? dataHideSelectors : defaultHideSelectors;
  const minUpwardPxToShow = 11;
  const hideNearTopPx = 24;
  const showDurationMs = 400;
  const hideDurationMs = 300;

  const intersectingElements = new Set();
  let initialized = false;
  let lastScrollY = window.scrollY;
  let isScrollingUp = false;
  let upwardScrollDistance = 0;
  let barVisible = false;
  let hideTimerId = null;
  let hiddenByOutsideClick = false;
  let allowOutsideClickRestore = false;

  const setBarTransition = (durationMs, easing) => {
    bar.style.transition = `transform ${durationMs}ms ${easing}, opacity ${durationMs}ms ${easing}`;
    bar.style.willChange = 'transform, opacity';
  };

  const showBar = () => {
    if (barVisible) return;
    barVisible = true;

    if (hideTimerId) {
      clearTimeout(hideTimerId);
      hideTimerId = null;
    }

    if (bar.style.display === 'none') {
      bar.style.transition = 'none';
      bar.style.display = '';
      bar.style.visibility = 'visible';
      bar.style.transform = 'translateY(115%)';
      bar.style.opacity = '0';
      bar.style.pointerEvents = 'none';
      // Force style flush so the next frame can animate cleanly from hidden state.
      bar.offsetHeight;
    }

    setBarTransition(showDurationMs, 'cubic-bezier(0.33, 1, 0.68, 1)');
    bar.style.visibility = 'visible';
    bar.style.transform = 'translateY(0)';
    bar.style.opacity = '1';
    bar.style.pointerEvents = 'auto';
  };

  const hideBar = () => {
    if (!barVisible) return;
    barVisible = false;

    if (hideTimerId) {
      clearTimeout(hideTimerId);
      hideTimerId = null;
    }

    setBarTransition(hideDurationMs, 'cubic-bezier(0.32, 0, 0.67, 0)');
    bar.style.display = '';
    bar.style.visibility = 'visible';
    bar.style.transform = 'translateY(115%)';
    bar.style.opacity = '0';
    bar.style.pointerEvents = 'none';

    hideTimerId = setTimeout(() => {
      if (barVisible) return;
      bar.style.display = 'none';
      bar.style.visibility = 'hidden';
    }, hideDurationMs);
  };

  const updateBarVisibility = () => {
    if (!initialized) return;

    const shouldHideByConfig = intersectingElements.size > 0;
    const shouldHideNearTop = hideNearTop && window.scrollY <= hideNearTopPx;
    const shouldHideForDirection = hideOnScrollUp && (
      !isScrollingUp || (!hiddenByOutsideClick && upwardScrollDistance < minUpwardPxToShow)
    );
    const shouldHideForOutsideClick = hiddenByOutsideClick && !allowOutsideClickRestore;
    const shouldHide = shouldHideByConfig
      || shouldHideNearTop
      || shouldHideForDirection
      || shouldHideForOutsideClick;

    allowOutsideClickRestore = false;

    if (shouldHide) {
      hideBar();
      return;
    }

    hiddenByOutsideClick = false;
    showBar();
  };

  const isInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  };

  // Start hidden to avoid flash before observers run
  bar.style.display = 'none';
  bar.style.visibility = 'hidden';
  bar.style.transform = 'translateY(115%)';
  bar.style.opacity = '0';
  bar.style.pointerEvents = 'none';

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        intersectingElements.add(entry.target);
      } else {
        intersectingElements.delete(entry.target);
      }
    });
    if (initialized) updateBarVisibility();
  }, {
    threshold: 0,
    rootMargin: '0px'
  });

  hideSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      if (isInViewport(el)) {
        intersectingElements.add(el);
      }
      observer.observe(el);
    });
  });

  if (hideOnScrollUp || hideNearTop || shouldHideOnOutsideClick) {
    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      const deltaY = currentScrollY - lastScrollY;
      lastScrollY = currentScrollY;

      if (deltaY > 0) {
        isScrollingUp = false;
        upwardScrollDistance = 0;
      } else if (deltaY < 0) {
        isScrollingUp = true;
        upwardScrollDistance += Math.abs(deltaY);
      }

      if (hideOnScrollUp && deltaY > 0) {
        hideBar();
        return;
      }

      if (hiddenByOutsideClick) {
        allowOutsideClickRestore = true;
      }

      updateBarVisibility();
    }, { passive: true });
  }

  if (shouldHideOnOutsideClick) {
    document.addEventListener('click', (event) => {
      if (!barVisible) return;

      const eventPath = typeof event.composedPath === 'function' ? event.composedPath() : [];
      const clickedInsideBar = bar.contains(event.target) || eventPath.includes(bar);

      if (clickedInsideBar) return;

      hiddenByOutsideClick = true;
      hideBar();
    });
  }

  // Wait a frame so observers register, then decide visibility to avoid flash
  requestAnimationFrame(() => {
    initialized = true;
    updateBarVisibility();
  });

  const buttonBarLink = document.querySelector('[data-button-bar-link]');
  const stickyButton = bar.querySelector('.button-special');
  const defaultCtaSuffix = ' - Buy Now';

  const ensureStickyButtonStyles = () => {
    if (document.getElementById('button-bar-inline-pricing-style')) return;

    const styleEl = document.createElement('style');
    styleEl.id = 'button-bar-inline-pricing-style';
    document.head.appendChild(styleEl);
  };

  const applyCtaPosition = (parts) => {
    const { priceWrapEl, originalPriceEl, salePriceEl, suffixEl } = parts;
    const isBefore = (stickyButton?.dataset.ctaPosition || '').trim().toLowerCase() === 'before';

    if (isBefore) {
      priceWrapEl.append(suffixEl, originalPriceEl, salePriceEl);
      return;
    }

    priceWrapEl.append(originalPriceEl, salePriceEl, suffixEl);
  };

  const getStickyButtonParts = () => {
    if (!stickyButton) return null;

    let contentEl = stickyButton.querySelector('.button-special__content');
    let quantityEl = stickyButton.querySelector('.button-special__quantity');
    let priceWrapEl = stickyButton.querySelector('.button-special__price-wrap');
    let originalPriceEl = stickyButton.querySelector('.button-special__price-original');
    let salePriceEl = stickyButton.querySelector('.button-special__price-sale');
    let suffixEl = stickyButton.querySelector('.button-special__suffix');

    if (contentEl && quantityEl && priceWrapEl && originalPriceEl && salePriceEl && suffixEl) {
      return { contentEl, quantityEl, priceWrapEl, originalPriceEl, salePriceEl, suffixEl };
    }

    ensureStickyButtonStyles();

    contentEl = document.createElement('span');
    contentEl.className = 'button-special__content';

    quantityEl = document.createElement('span');
    quantityEl.className = 'button-special__quantity';
    quantityEl.textContent = '1';
    quantityEl.setAttribute('aria-hidden', 'true');

    priceWrapEl = document.createElement('span');
    priceWrapEl.className = 'button-special__price-wrap';

    originalPriceEl = document.createElement('span');
    originalPriceEl.className = 'button-special__price-original';
    originalPriceEl.style.display = 'none';

    salePriceEl = document.createElement('span');
    salePriceEl.className = 'button-special__price-sale';

    suffixEl = document.createElement('span');
    suffixEl.className = 'button-special__suffix';

    const parts = { contentEl, quantityEl, priceWrapEl, originalPriceEl, salePriceEl, suffixEl };
    applyCtaPosition(parts);
    contentEl.append(quantityEl, priceWrapEl);

    stickyButton.textContent = '';
    stickyButton.appendChild(contentEl);

    return parts;
  };

  const getCheckoutClearCartSetting = () => {
    return (bar.getAttribute('data-checkout-clear-cart') || '').trim().toLowerCase() === 'true';
  };

  const normalizeQuantity = (value) => {
    const parsed = parseInt(String(value ?? ''), 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
  };

  const getQuantityFromScope = (scopeRoot) => {
    if (!scopeRoot || !scopeRoot.querySelector) return null;

    const formQuantityInput = scopeRoot.querySelector('form[action="/cart/add"] input[name="quantity"]');
    if (formQuantityInput && formQuantityInput.value) {
      return normalizeQuantity(formQuantityInput.value);
    }

    const quantityComponent = scopeRoot.querySelector('quantity-selector-component');
    if (quantityComponent) {
      const shadowInput = quantityComponent.shadowRoot
        ? quantityComponent.shadowRoot.querySelector('input[ref="quantityInput"]')
        : null;
      const lightDomInput = quantityComponent.querySelector('input[ref="quantityInput"]');
      const componentInput = shadowInput || lightDomInput;
      if (componentInput && componentInput.value) {
        return normalizeQuantity(componentInput.value);
      }
    }

    const fallbackQuantityInput = scopeRoot.querySelector('input[name="quantity"]');
    if (fallbackQuantityInput && fallbackQuantityInput.value) {
      return normalizeQuantity(fallbackQuantityInput.value);
    }

    return null;
  };

  const getCurrentQuantity = () => {
    const productInformationSection = document.querySelector('.product-information');
    if (!productInformationSection) return 1;

    const sectionQuantity = getQuantityFromScope(productInformationSection);
    if (sectionQuantity) return sectionQuantity;

    return 1;
  };

  const updateStickyButtonDisplay = ({ salePriceText, originalPriceText, quantity }) => {
    if (!stickyButton) return;

    const parts = getStickyButtonParts();
    if (!parts) return;

    const ctaSuffix = stickyButton.dataset.ctaSuffix || defaultCtaSuffix;
    const basePrice = stickyButton.dataset.basePrice || '';
    const safeSalePrice = (salePriceText || basePrice || '').trim();
    const safeOriginalPrice = (originalPriceText || '').trim();
    const safeQuantity = normalizeQuantity(quantity);

    parts.quantityEl.textContent = String(safeQuantity);
    parts.salePriceEl.textContent = safeSalePrice;
    parts.suffixEl.textContent = ctaSuffix;

    const showOriginalPrice = safeOriginalPrice && safeOriginalPrice !== safeSalePrice;
    parts.originalPriceEl.textContent = safeOriginalPrice;
    parts.originalPriceEl.style.display = showOriginalPrice ? '' : 'none';
  };

  const resolvePriceElements = () => {
    const legacyTotal = document.querySelector('#total-price');
    const legacyCompare = document.querySelector('#compare-price');
    if (legacyTotal && legacyCompare) {
      return {
        salePriceEl: legacyTotal,
        comparePriceEl: legacyCompare,
        priceContainer: legacyTotal.parentElement
      };
    }

    const priceContainer =
      document.querySelector('.product-information product-price [ref="priceContainer"]') ||
      document.querySelector('product-price [ref="priceContainer"]');

    if (!priceContainer) {
      return { salePriceEl: null, comparePriceEl: null, priceContainer: null };
    }

    return {
      salePriceEl: priceContainer.querySelector('.price'),
      comparePriceEl: priceContainer.querySelector('.compare-at-price'),
      priceContainer
    };
  };

  const isComparePriceVisible = (comparePriceEl) => {
    if (!comparePriceEl) return false;

    const compareGroup = comparePriceEl.closest('[role="group"]') || comparePriceEl;
    return getComputedStyle(compareGroup).display !== 'none' && getComputedStyle(comparePriceEl).display !== 'none';
  };

  if (stickyButton) {
    const productInformationSection = document.querySelector('.product-information');
    const shouldForceDefaultQuantity = !productInformationSection;

    const syncStickyButtonFromDom = () => {
      const { salePriceEl, comparePriceEl } = resolvePriceElements();
      const salePriceText = salePriceEl && salePriceEl.textContent ? salePriceEl.textContent.trim() : '';
      const comparePriceIsVisible = isComparePriceVisible(comparePriceEl);
      const originalPriceText = comparePriceIsVisible && comparePriceEl && comparePriceEl.textContent
        ? comparePriceEl.textContent.trim()
        : '';

      updateStickyButtonDisplay({
        salePriceText,
        originalPriceText,
        quantity: shouldForceDefaultQuantity ? 1 : getCurrentQuantity()
      });
    };

    syncStickyButtonFromDom();
    requestAnimationFrame(syncStickyButtonFromDom);
    setTimeout(syncStickyButtonFromDom, 250);

    document.addEventListener('brick:price-updated', (event) => {
      const detail = event && event.detail ? event.detail : {};
      updateStickyButtonDisplay({
        salePriceText: detail.totalPriceText || '',
        originalPriceText: detail.originalPriceText || '',
        quantity: shouldForceDefaultQuantity ? 1 : (detail.quantity != null ? detail.quantity : getCurrentQuantity())
      });
    });

    const initialPriceElements = resolvePriceElements();
    const priceObserverTarget = initialPriceElements.priceContainer || initialPriceElements.salePriceEl;

    if (priceObserverTarget) {
      const priceObserver = new MutationObserver(() => {
        syncStickyButtonFromDom();
      });

      priceObserver.observe(priceObserverTarget, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    const bindQuantitySyncListeners = (scopeRoot) => {
      if (!scopeRoot || !scopeRoot.querySelectorAll) return;

      const quantityInputs = new Set();
      scopeRoot.querySelectorAll('form[action="/cart/add"] input[name="quantity"], input[name="quantity"], quantity-selector-component input[ref="quantityInput"]').forEach((input) => {
        quantityInputs.add(input);
      });

      scopeRoot.querySelectorAll('quantity-selector-component').forEach((component) => {
        if (!component.shadowRoot) return;
        const shadowInput = component.shadowRoot.querySelector('input[ref="quantityInput"]');
        if (shadowInput) quantityInputs.add(shadowInput);
      });

      quantityInputs.forEach((input) => {
        input.addEventListener('change', syncStickyButtonFromDom);
        input.addEventListener('input', syncStickyButtonFromDom);
      });
    };

    bindQuantitySyncListeners(productInformationSection || document);
  }

  if (buttonBarLink) {
    const productForm = document.querySelector('form[action="/cart/add"]');

    if (productForm) {
      const scrollToProductForm = () => {
        const viewportHeight = window.innerHeight;
        const targetPosition = viewportHeight * 0.66;
        const y = productForm.getBoundingClientRect().top + window.pageYOffset - targetPosition;
        window.scrollTo({ top: y, behavior: 'smooth' });
      };

      const getButtonBarAction = () => {
        return (bar.getAttribute('data-button-action') || '').trim().toLowerCase();
      };

      buttonBarLink.addEventListener('click', async (e) => {
        e.preventDefault();

        const buttonAction = getButtonBarAction();
        const goToCheckout = buttonAction === 'checkout';
        const addToCart = buttonAction === 'add-to-cart';

        if (!goToCheckout && !addToCart) {
          scrollToProductForm();
          return;
        }

        const shouldClearCartBeforeCheckout = goToCheckout && getCheckoutClearCartSetting();

        buttonBarLink.setAttribute('aria-busy', 'true');
        buttonBarLink.style.pointerEvents = 'none';

        const resetBusy = () => {
          buttonBarLink.removeAttribute('aria-busy');
          buttonBarLink.style.pointerEvents = '';
        };

        try {
          const formData = new FormData(productForm);
          const variantId = formData.get('id');

          if (!variantId) {
            scrollToProductForm();
            resetBusy();
            return;
          }

          if (shouldClearCartBeforeCheckout) {
            const clearCartResponse = await fetch('/cart/clear.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json'
              }
            });

            if (!clearCartResponse.ok) {
              throw new Error('Failed to clear cart before checkout.');
            }
          }

          const tempSubmitter = document.createElement('button');
          tempSubmitter.type = 'submit';
          tempSubmitter.dataset.buttonAction = goToCheckout ? 'straight-to-checkout' : 'add-to-cart';
          tempSubmitter.style.display = 'none';
          productForm.appendChild(tempSubmitter);

          if (addToCart) {
            const onCartSettled = () => {
              resetBusy();
              document.removeEventListener('cart:update', onCartSettled);
              document.removeEventListener('cart:error', onCartSettled);
            };
            document.addEventListener('cart:update', onCartSettled, { once: true });
            document.addEventListener('cart:error', onCartSettled, { once: true });
            setTimeout(onCartSettled, 8000);
          }

          if (typeof productForm.requestSubmit === 'function') {
            productForm.requestSubmit(tempSubmitter);
          } else {
            tempSubmitter.click();
          }

          // Delay removal to safely allow the browser to snapshot the native form submission
          setTimeout(() => {
            if (tempSubmitter.parentElement) tempSubmitter.remove();
          }, 0);

          if (goToCheckout) {
            window.addEventListener('pageshow', function onPageShow(event) {
              if (event.persisted) {
                resetBusy();
                window.removeEventListener('pageshow', onPageShow);
              }
            });
          }
        } catch (error) {
          console.error(error);
          scrollToProductForm();
          resetBusy();
        }
      });
    }
  }
}